/**
 * Строка фильтров под заголовком страницы.
 * Фильтры слева, actions (кнопки, ссылки) справа.
 */
import '../../styles/components/filters.css'

export default function FiltersRow({ children, actions, className = '' }) {
  return (
    <div className={`filters-row ${className}`.trim()}>
      <div className="filters-row-left">{children}</div>
      {actions && <div className="filters-row-actions">{actions}</div>}
    </div>
  )
}
